import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useAuth } from '../../context/AuthContext';
import { useFieldLayout } from '../../hooks/useMedia';
import { ToolFundCatalog } from '../../modules/ToolFundDashboard/components/ToolFundCatalog';
import { ToolCatalogPhone } from '../../modules/ToolFundDashboard/phone/ToolCatalogPhone';
export const Route = createFileRoute('/toolFundCatalog/$catalogItemId')({
  component: RouteComponent,
  params: z.object({
    catalogItemId: z.coerce.number().positive(),
  }),
  head: () => {
    return {
      meta: [{ title: 'Tool Fund Catalog' }],
    };
  },
});

function RouteComponent() {
  const { catalogItemId } = Route.useParams();
  const { user } = useAuth();
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) {
    // The same admin check as the catalog list, so a catalog admin can edit the tool here.
    const isCatalogAdmin = user.permissionGroups.some(
      (perm) => perm.name === 'ToolFundCatalogAdmin',
    );
    return <ToolCatalogPhone catalogItemId={catalogItemId} enableManagement={isCatalogAdmin} />;
  }
  return <ToolFundCatalog catalogItemId={catalogItemId} />;
}
